/**
 * Front-end behavior for Assets Grid (scoped to block instances).
 */
export class AssetsGridFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="assets-grid"]' ).forEach( ( el ) => {
			el.classList.add( 'assets-grid-enhanced' );
		} );
	}
}
